module.exports = "/packs/images/svg/facilities/event_conference_room~a388352ddddf1c61bac39af7a0985fe0.svg";